// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__t7VZz","input":"SearchBox_input__TNmJC"};